// Auto-generated client configuration - DO NOT EDIT MANUALLY
// Generated by frontend/scripts/prepare-client.js from clients/{CLIENT_ID}/config.json.
// This file is regenerated at every build and is gitignored.

export const CLIENT_CONFIG = {
  "client_id": "reshaped",
  "auth": {},
  "theme": {
    "name": "Reshaped",
    "chat": {
      "showWordmark": true
    },
    "colors": {
      "primary": "#790265",
      "secondary": "#F5E6F3",
      "accent": "#790265",
      "background": "#FFFFFF",
      "surface": "#F9F5FB",
      "text": {
        "primary": "#2D2D2D",
        "secondary": "#475569",
        "muted": "#94A3B8"
      },
      "success": "#10B981",
      "warning": "#F59E0B",
      "error": "#EF4444"
    },
    "branding": {
      "logoUrl": "/assets/reshaped/logo.svg",
      "faviconUrl": "/assets/reshaped/favicon.ico",
      "agentIconUrl": "/assets/reshaped/agentIcon.svg",
      "internalIconUrl": "/assets/reshaped/internalIcon.svg",
      "companyName": "Reshaped",
      "tagline": "Reshaping the Future with AI",
      "supportEmail": "support@reshaped.nl",
      "backgroundImage": "/assets/reshaped/background.svg"
    },
    "typography": {
      "fontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "headingFontFamily": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "weights": {
        "body": 500,
        "heading": 700
      }
    },
    "layout": {
      "sidebarWidth": "280px",
      "headerHeight": "64px",
      "borderRadius": "8px"
    },
    "customTexts": {
      "welcomeMessage": "Welcome to Reshaped AI Assistant",
      "chatPlaceholder": "How can Reshaped AI help you today?",
      "footerText": "Powered by Reshaped AI Technology",
      "thinkingMessages": {
        "en": [
          "Churning the wheel",
          "Consulting Karel",
          "~~ Hawaiian noises~~",
          "Moving those microwave ovens",
          "Customizing kitchen deliveries",
          "Procuring goats",
          "Hiring more I's"
        ]
      },
      "vanillaAgent": {
        "description": "Your Reshaped AI sidekick. Writes, summarizes, translates, and digs through documents you upload — no goats required.",
        "exampleQuestions": [
          "Turn these notes into a clean summary.",
          "Help me write a Slack message to the team.",
          "What does this contract say about deadlines?"
        ]
      }
    }
  }
};

export const CLIENT_ID = CLIENT_CONFIG.client_id;

export const IS_DEVELOPMENT = false;
